import { render, staticRenderFns } from "./ScanGoods.vue?vue&type=template&id=3e622e78&scoped=true&"
import script from "./ScanGoods.vue?vue&type=script&lang=js&"
export * from "./ScanGoods.vue?vue&type=script&lang=js&"
import style0 from "./ScanGoods.vue?vue&type=style&index=0&id=3e622e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e622e78",
  null
  
)

export default component.exports